import {
  ADD_IMAGE,
  LOAD_IMAGES_BY_BOOK_ID,
  DELETE_IMAGES,
  DELETE_IMAGE } from '../../action-types/entities/images';

import { imagesLoading } from '../../actions/entities/io';
/**
 * image model
 * {
 *    placeholders: [id],
 * }
 */

export const addImage = (image, placeholders = []) => ({
  type: ADD_IMAGE,
  image,
  placeholders,
});

export const loadImages = images => (dispatch) => {
  dispatch(imagesLoading('isLoading'));
  images.forEach((image) => {
    dispatch(addImage(image));
  });
  dispatch(imagesLoading('loaded'));
};

export const loadImagesByBookId = bookState => ({
  type: LOAD_IMAGES_BY_BOOK_ID,
  bookState,
});

export const deleteImages = exception => ({
  type: DELETE_IMAGES,
  exception,
});

export const deleteImage = imageId => ({
  type: DELETE_IMAGE,
  imageId,
});




// WEBPACK FOOTER //
// ./src/redux/actions/entities/images.js